// extracted by mini-css-extract-plugin
module.exports = {"container":"folderDragLayer_container__425ed","name":"folderDragLayer_name__dMFy7","count":"folderDragLayer_count__GjJzz"};